import React, { useEffect, useState } from "react";
import { RaceDTO } from "../../../interfaces/RaceDTO";
import SpeakerViewButton from "./SpeakerViewButton";
import SpeakerViewScroll from "./SpeakerViewScroll";
import { TimingPositionsDTO } from "../../../interfaces/TimingPositionsDTO";
import { ViewType } from "../../../interfaces/internal/ViewProps";
import ResultTable from "../resultviews/ResultTable";
import { TimeDTO } from "../../../interfaces/TimeDTO";
import './speakerstyle.css'

interface Props {
  race: RaceDTO;
  classid: number | null;
  level: number | null;
  Tpos: TimingPositionsDTO | null;
  vType: ViewType;
  Ipos?: number | null;
  vwindPropId: number;
  timeScroll: {[key:number]: TimeDTO} | null;
}
const SepakerView = ({
  race,
  classid,
  level,
  Tpos,
  vType,
  Ipos,
  vwindPropId,
  timeScroll,
}: Props) => {
  const clickedClass = (classID: number) => {
    if (classID === -1){
      setAutoChangeClass(true);
    }
    else{
      setSelectedClass(classID);
      setAutoChangeClass(false);
    }
    
  };
  const [selectedClass,setSelectedClass] = useState<number | null>(null);
  const [fysPosFinish,setFysPosFinish] = useState<number>(-1);
  const [fysPosBefore,setFysPosBefore] = useState<number>(-1);
  const [autoChangeClass,setAutoChangeClass] = useState<boolean>(false);

  useEffect(() =>{
    // const fysPoses:number = 0;
    let Clas = race.Class[Math.min(...Object.keys(race.Class).map(Number))];
    if (selectedClass){
      Clas = race.Class[selectedClass];
    }
    let timPoses = Clas.Level[level ? level : 1].TimePos;
    const filteredSortedKeys = Object.keys(timPoses)
    .map(Number) // Convert keys to numbers
    .filter(key => key < 1000) // Keep only keys under 1000
    .sort((a, b) => b - a) // Sort in descending order
    .slice(0, 2); // Get the top two keys
    setSelectedClass(classid);
    // const topTwoValues = filteredSortedKeys.map(key => timPoses[key]);

    if (filteredSortedKeys.length > 1){
      setFysPosFinish(timPoses[filteredSortedKeys[0]].StationID);
      setFysPosBefore(timPoses[filteredSortedKeys[1]].StationID);
    }
    else{
      setFysPosFinish(timPoses[filteredSortedKeys[0]].StationID);
      setFysPosBefore(0);
    }

  },[]);

  useEffect(() => {
     
  },[fysPosBefore])

  const onChangeClass = (inp:number) =>{
    if (autoChangeClass){
      setSelectedClass(inp);
    }
     console.log(inp);
    // setSelectedClass(inp);
  };

  return (
    <div className="SpeakerView">
      <div className="SpeakerViewTop">
        <span className="SpeakerViewPosition">Postion-1 {fysPosBefore}</span>
        <div className="SpeakerViewScroll">
          <SpeakerViewScroll race={race} FysPosId={fysPosBefore} FysPosAfter={fysPosFinish} ClassID={null} timeScroll={timeScroll} IsScroll={false}  />
        </div>
      </div>
      <div className="SpeakerViewMiddle">
      <span className="SpeakerViewPosition">Scroll Finish {fysPosFinish}</span>
        <div className="SpeakerViewScroll">
        <SpeakerViewScroll onChange={onChangeClass} race={race} FysPosId={fysPosFinish} ClassID={null} timeScroll={timeScroll} IsScroll={true} />
      </div>
      </div>
      <div className="SpeakerViewBottom">
        <div className="SpeakerViewResult">
        <ResultTable
        classid={selectedClass}
        level={level}
        Tpos={null}
        Ipos={999}
        race={race}
        vType={vType}
        vwindPropId={vwindPropId}
      ></ResultTable>
        </div>
        <div className="SpeakerViewClass">
        <SpeakerViewButton
              active={autoChangeClass}
                onClick={() => clickedClass(-1)}
                key={-1}
                text={"Auto"}
              />
          {Object.keys(race.Class).map((obj,index) => {
            return (
              <SpeakerViewButton
              active={selectedClass?.toString() === obj}
                onClick={() => clickedClass(parseInt(obj))}
                key={index}
                text={race.Class[parseInt(obj)].Name}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SepakerView;
